export default __webpack_public_path__ + "static/media/img-slider-cmbus-7.88131f4c.png";